export const ASESMEN_TYPE = { Individu: "individu", Kelompok: "kelompok" };

export const isIndividu = (type) => type === ASESMEN_TYPE.Individu;
export const isKelompok = (type) => type === ASESMEN_TYPE.Kelompok;

export const PetunjukUmumIndividu = [
  "Bapak dan Ibu diharapkan dapat memberikan evaluasi terhadap diri sendiri",
  "Evaluasi diisikan untuk 10 (sepuluh) aspek",
  "Pengisian dilakukan dengan cara memilih salah satu dari jawaban yang tersedia",
];
export const PetunjukUmumKelompok = [
  "Bapak/Ibu pimpinan unit beserta anggota tim diharapkan dapat bekerjasama memberikan evaluasi bagi unit lainnya yang ada di Fasilkom UI",
  "Penentuan unit mana yang akan dinilai adalah dengan melihat intensitas kerjasama terkait operasional Fasilkom UI antara unit Bapak/Ibu dengan unit yang akan dinilai",
  "Apabila Bapak/Ibu merasa bahwa minim bahkan tidak pernah menjalin kerjasama terkait operasional Fasikom UI dengan unit tersebut maka tidak diperlukan evaluasi dari Bapak/Ibu bagi unit dimaksud",
  "Dalam penilaian kelompok, dimohon tidak hanya mengasosiasikan pada satu orang namun hasil kerja dari unit tersebut",
];
